import { render, staticRenderFns } from "./TwIpDnHistory.vue?vue&type=template&id=bf3ffef4&scoped=true&"
import script from "./TwIpDnHistory.vue?vue&type=script&lang=js&"
export * from "./TwIpDnHistory.vue?vue&type=script&lang=js&"
import style0 from "./TwIpDnHistory.vue?vue&type=style&index=0&id=bf3ffef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3ffef4",
  null
  
)

export default component.exports